import { BASE_URL, BUSINESS_NAME } from "@/core/constants/business";

export const META = {
  title: `About ${BUSINESS_NAME} | DC & Baltimore Cannabis Dispensary`,
  meta_description:
    "Learn about Street Lawyer Services, Washington DC's premier cannabis dispensary. Founded by Lonny Bramzon, we provide premium cannabis products in DC and Baltimore.",
  canonicalUrl: "/about",
  keywords:
    "Street Lawyer Services, Lonny the Street Lawyer, DC cannabis dispensary, marijuana dispensary Washington DC, Baltimore cannabis, recreational cannabis, premium cannabis products",
};

export const generateAboutRichSnippet = () => {
  return {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: BUSINESS_NAME,
    url: `${BASE_URL}/about`,
    logo: `${BASE_URL}/images/logo/street-lawyer-services-logo.png`,
    description: META.meta_description,
    foundingDate: "2019",
    founders: [
      {
        "@type": "Person",
        name: "Lonny Bramzon",
        jobTitle: "CEO & Founder",
        sameAs: [
          "https://www.instagram.com/lonnythestreetlawyer/",
          "https://www.youtube.com/@streetlawyerpodcast",
        ],
      },
    ],
    address: [
      {
        "@type": "PostalAddress",
        streetAddress: "3400 Connecticut Avenue NW",
        addressLocality: "Washington",
        addressRegion: "DC",
        postalCode: "20008",
        addressCountry: "USA",
      },
      {
        "@type": "PostalAddress",
        streetAddress: "30 Light Street",
        addressLocality: "Baltimore",
        addressRegion: "MD",
        postalCode: "21202",
        addressCountry: "USA",
      },
    ],
    contactPoint: {
      "@type": "ContactPoint",
      telephone: "(202) 340-8277",
      contactType: "customer service",
      email: "info@streetlawyerservices.com",
    },
  };
};
